<template>
  <v-row>
    <v-col cols="10">
      <input-select
        id="input:idAgrupamento"
        v-model="payload.idAgrupamento"
        :items="agrupamentosOptions"
        :rules="[requiredRule]"
        label="Agrupamento"
        :loading="loading"
        clearable
        hide-selected
        outlined
        required
      />
    </v-col>
    <v-col cols="2">
      <create-group-modal @success="setListGroup($event)" />
    </v-col>
  </v-row>
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import ProdutoGroupRequest from 'Modules/contacard/produto/groups/ProdutoGroupRequest';
import RequestSelectMixin from '@/app/arch/mixins/RequestSelectMixin';
import CreateGroupModal from '../modals/CreateGroupModal.vue';

export default {
  name: 'ProdutoAgrupamento',
  components: { CreateGroupModal },
  mixins: [RulesMixin, RequestSelectMixin],
  props: {
    payload: {
      type: Object,
      default() {
        return {
          idAgrupamento: '',
        };
      },
    },
  },
  data: () => ({
    requestClass: ProdutoGroupRequest,
    agrupamentosOptions: [],
    loading: false,
    agrupamentoMessageError: 'Falha ao buscar agrupamentos',
  }),
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.makeRequest();
    },
    makeRequest() {
      this.serviceCall(
        this.requestClass.list(
          this.makeParams(),
        ),
        this.setDataOptions(
          'agrupamentosOptions',
          'nomProdutoAgrupamento',
        ),
        this.agrupamentoMessageError,
        this.requestCallBack,
      );
    },
    requestCallBack() {
      this.loading = false;
    },
  },
};
</script>
